import htmlTemplate from './hvt-fulfillment.html';

(function () {
    "use strict";

    angular.module("cardspotWeb")
        .config(configHvtFulfillment);

    configHvtFulfillment.$inject = ["$routeProvider", "NAV_URLS", "CLAIMS"];

    function configHvtFulfillment($routeProvider, NAV_URLS, CLAIMS) {

        $routeProvider
            .when(NAV_URLS.HVT_FULFILLMENT, {
                template: htmlTemplate,
                controller: "HvtFulfillment",
                controllerAs: "model"
            });
    }
}());